import { render, staticRenderFns } from "./Home-listado-detalle.vue?vue&type=template&id=37b8845d&scoped=true&lang=pug"
import script from "./Home-listado-detalle.vue?vue&type=script&lang=js"
export * from "./Home-listado-detalle.vue?vue&type=script&lang=js"
import style0 from "./Home-listado-detalle.vue?vue&type=style&index=0&id=37b8845d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8845d",
  null
  
)

export default component.exports